import React from "react";

import { IRouteProps, RootRouter, IRouteMiddlewareProps, RouteMiddleware } from "app/core/router";
// import SplashScreen from "app/views/containers/splash-screen";
// import UploadJson from "app/views/containers/upload-json";
import { store } from "app/states/store";

const authMiddleware: RouteMiddleware = ({ component: Component, redirect: Redirect }: IRouteMiddlewareProps) => {
    const { isAuthenticated } = store.getState().auth;
    return (props: any) =>
        isAuthenticated ? <div>Child Component<Component {...props} /></div> : <Redirect to="/login" />;
};

const appRoutes: IRouteProps[] = [
    // { path: "/", exact: true, component: SplashScreen },
    // { path: "/", exact: true, component: UploadJson },
    {
        path: "/",
        exact: true,
        loadChildren: () => import("app/views/containers/dashboard")
    },
    { path: "/login", exact: true, loadChildren: () => import("app/views/containers/Login") },
    {
        path: "/home", exact: true,
        loadChildren: () => import("app/views/containers/Home"),
        middleware: authMiddleware
    }

];

export const AppRouter: React.FC = () => <RootRouter routes={appRoutes} />;
